var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.547,
    height: 16.485,
    viewBox: "0 0 24.547 16.485",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 188"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h4.359l5.484 11.015H7.37L3.009 2.158H.986z",
    "data-name": "Path 76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7 0h17.848l-5.529 10.925h-6.832l-1.035-2.042h6.111l3.871-6.815H10.206l4.229 8.857h-2.248z",
    "data-name": "Path 77"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.776,
    cy: 1.776,
    r: 1.776,
    "data-name": "Ellipse 46",
    transform: "translate(6.821 12.932)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.776,
    cy: 1.776,
    r: 1.776,
    "data-name": "Ellipse 47",
    transform: "translate(16.059 12.932)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.84f9e61c8cbfcc94adf88b0a6d7856b6.svg";
export { ForwardRef as ReactComponent };